// Service
import { apiServices } from "@core/services/appService";

const SET_DATA_REVIEW_LIST = 'app/SET_DATA_REVIEW_LIST';

function loadReviewList() {
    return dispatch => {
        apiServices({}, "get", `/general/review/list-cache/${process.env.REACT_APP_DEFAULT_AGENT_CODE}`).then((data) => {
            const statusCode = data.code;
            if (statusCode === 200 || statusCode === 0) {
                const result = data.result;

                dispatch({
                    type: SET_DATA_REVIEW_LIST,
                    payload: {
                        items: result
                    }
                });
            }
            else {
                dispatch({
                    type: SET_DATA_REVIEW_LIST,
                    payload: {
                        items: null
                    }
                });
            }
        });
    }
}

export {
    loadReviewList,
    SET_DATA_REVIEW_LIST
}